import { a as __spreadArray, _ as __read } from '../../../_tslib-7a01aab4.js';
import { makeObservable, observable, action } from 'mobx';

var ChatStore = /** @class */ (function () {
    function ChatStore() {
        this.chatMessageData = [];
        this.unReadCount = 0;
        this.isTypingNotAllowed = true;
        this.quickWords = [];
        this.isQuickWordsScrolling = false;
        this.isMessagesReceived = false;
        this.isShowChat = false;
        makeObservable(this, {
            unReadCount: observable,
            isQuickWordsScrolling: observable,
            isTypingNotAllowed: observable,
            isMessagesReceived: observable,
            isShowChat: observable,
            chatMessageData: observable.deep,
            quickWords: observable.deep,
            setQuickWords: action.bound,
            setIsShowChat: action.bound,
            updateUnReadCount: action.bound,
            setChatMessageHistory: action.bound,
            updateChatMessageData: action.bound,
            setIsTypingNotAllowed: action.bound,
            setIsQuickWordsScrolling: action.bound,
            setIsMessagesReceived: action.bound,
        });
    }
    ChatStore.prototype.updateUnReadCount = function (count) {
        this.unReadCount = count;
    };
    ChatStore.prototype.updateChatMessageData = function (data) {
        this.chatMessageData = __spreadArray(__spreadArray([], __read(this.chatMessageData), false), [data], false);
    };
    ChatStore.prototype.setChatMessageHistory = function (data) {
        this.chatMessageData = data;
        if (!this.isMessagesReceived) {
            this.setIsMessagesReceived(true);
        }
    };
    ChatStore.prototype.setQuickWords = function (quickWords) {
        this.quickWords = quickWords;
    };
    ChatStore.prototype.setIsTypingNotAllowed = function (isTypingNotAllowed) {
        this.isTypingNotAllowed = isTypingNotAllowed;
    };
    ChatStore.prototype.setIsQuickWordsScrolling = function (isQuickWordsScrolling) {
        this.isQuickWordsScrolling = isQuickWordsScrolling;
    };
    ChatStore.prototype.setIsMessagesReceived = function (bool) {
        this.isMessagesReceived = bool;
    };
    ChatStore.prototype.setIsShowChat = function (bool) {
        this.isShowChat = bool;
    };
    return ChatStore;
}());
var chatStore = new ChatStore();

export { ChatStore, chatStore };
